import React from "react"
import clsx from "clsx"
import { useDispatch, useSelector } from "react-redux"
import { useSCIMResourceManagement } from "hooks"
import { adminFacilityDepartmentShape } from "utils/propTypeShapes"
import EditDepartmentModal from "shared/modals/EditDepartmentModal"
import { updateDepartment, facilityId } from "reduxSlices/adminFacilitySlice"

const LIST_LAST_ON_FORMS_DESC = "appears last on forms"

const DepartmentHeader = ({ department }) => {
  const dispatch = useDispatch()

  const id = useSelector(facilityId)

  const { departmentsManagedBySCIM } = useSCIMResourceManagement()

  const updateDepartmentFields = (dept) => dispatch(updateDepartment(dept))
  const deptClassName = (departmentsManagedBySCIM && department.externalIdentifier) || department.listLastOnForms
    ? "mb-2"
    : ""

  return (
    <div className="flex gap-2 items-start">
      <div className="flex flex-col grow break-all">
        <div className={clsx(deptClassName, "text-base font-semibold")}>{department.name}</div>
        {
          departmentsManagedBySCIM
            && department.externalIdentifier
            && <div className="text-xs">{department.externalIdentifier}</div>
        }
        {
          department.listLastOnForms
            && <div className="text-xs">{LIST_LAST_ON_FORMS_DESC}</div>
        }
      </div>
      <EditDepartmentModal
        facilityId={id}
        department={department}
        onDepartmentUpdated={updateDepartmentFields}
      />
    </div>
  )
}

DepartmentHeader.propTypes = {
  department: adminFacilityDepartmentShape.isRequired,
}

export default DepartmentHeader
